import * as React from 'react';

import Alert from 'src/components/common/Alert';
import env from 'src/shared/env';
import './ShipFromRow.scss';
import i18n from 'src/translation/i18n';

interface IDeliverAddress {
  warehouseCode: string;
  description: string;
  quantity: number;
  name: string;
  code: string;
  addressLine1: string;
  addressLine2: string;
  addressLine4: string;
  stateCode: string;
  postalCode: string;
  pickUpOnly: boolean;
}

interface IShipFromRowProps {
  address: IDeliverAddress;
  type: string;
  selectedtab:number;
  selectedAddresses: object;
  handleInputChange: (
    warehouse: string,
    qty: string,
    available: number,
    setAlert: (params: any) => void
  ) => void;
  isBold: boolean;
  stateQty: string;
}

const ShipFromRow: React.FC<IShipFromRowProps> = ({
  address,
  type,
  selectedtab,
  selectedAddresses,
  handleInputChange,
  isBold,
  stateQty
}) => {
  const [alert, setAlert] = React.useState({
    show: false,
    type: '',
    message: ''
  });

  React.useEffect(() => {
    const warehouse = selectedAddresses[address.warehouseCode];
    if (warehouse && Number(warehouse.qty) > Number(warehouse.available)) {
      if(stateQty === "In Stock No Backorder") {
        selectedAddresses[address.warehouseCode].qty = address.quantity;
        setAlert({
          show: true,
          type: 'info',
          message:
            env.REACT_APP_BASE_ENVIRONMENT === 'CA'
              ? `${i18n.t('common.NoitemsBackOrderedOnly')}`
              : `We are no longer accepting backorders for this product. Please select valid quantity from in stock location(s).`
        });

     } else {
      setAlert({
        show: true,
        type: 'info',
        message:
          env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? `${i18n.t('common.itemsBackOrderedOnly')}`
            : `${Number(warehouse.qty) -
                warehouse.available} item(s) will be backordered. We will ship them as soon as the stocks are available for shipment.`
      });
     }
    }
  }, [selectedAddresses]);

  const handleCloseAlert = () => {
    setAlert({ show: false, type: '', message: '' });
  };
  

  return (
    <>
    {env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
          (type === 'shipping' || selectedtab === 1) &&  (address.pickUpOnly || address.name.includes('PU ONLY') || address.name.includes('PICK UP ONLY')) ? (""):(
    <div className="rp-ship-from-row--delivery-wrapper">
      <div className="rp-divider" />
      <div className="rp-ship-from-row--addresses--row">
        <div className="rp-ship-from-row--addresses--address">
          <div
            className="rp-ship-from-row--addresses--address--state"
            style={isBold ? { fontWeight: 'bold' } : null}
          >
            {env.REACT_APP_BASE_ENVIRONMENT === 'US'
              ? address.name.split(' PICK UP ONLY')[0]
              : address.name}             
          </div>
        </div>
        <div className="rp-ship-from-row--addresses--stock">
          <div>
            {address.quantity > 0
              ? `${address.quantity} ${i18n.t('common.inStock')}`
              : `${i18n.t('common.outOfStock')}`}
          </div>
        </div>
        <div className="rp-ship-from-row--addresses--quantity">
          {env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
          type === 'shipping' &&
          address.pickUpOnly ? (
            <label
              style={{
                fontSize: '10px',
                textAlign: 'right',
                width: '100%'
              }}
            >
              Pick up only
              {/* {i18n.t('common.pickUpOnly')} */}
            </label>
          ) : (
            <input aria-label="Choose the quantity of this product you want to add to your cart from this location" disabled={stateQty === "In Stock No Backorder" && address.quantity < 1 ? true : false}
              value={
                selectedAddresses[address.warehouseCode]
                  ? selectedAddresses[address.warehouseCode].qty
                  : ''
              }
              onChange={e =>
                handleInputChange(
                  address.warehouseCode,
                  e.target.value,
                  address.quantity,
                  setAlert
                )
              }
            />
          )}
        </div>
      </div>
      <div>
        {alert.show && (
          <Alert
            type={alert.type}
            styleClass={'rp-ship-from-row--tab-alert'}
            message={alert.message}
            icon={alert.type === 'error' ? 'rpds-error' : 'rpds-shipping'}
            handleCloseAlert={handleCloseAlert}
          />
        )}
      </div>
    </div>)}
    </>
  );
};

export default ShipFromRow;
